import React, {useEffect} from 'react'
import {useHistory, useLocation} from 'react-router-dom'

import HotWord from './partials/hot-word/HotWord'
import SearchOrder from 'enum/SearchOrder'
import Router from 'router/router'

import * as SearchReducer from 'store/search/reducer'
import * as css from './css/search'
import {observer} from "mobx-react";
import useMyStores from "@/hooks/useMyStores";

const ORDER = {
    asc: 'asc',
    des: 'des',
}

const ORDER_FILED = {
    price: 'currentPrice',
    saleNum: 'soldNum',
}

function Search(props) {
    const {children, className,} = props

    const {search:searchStore} = useMyStores();

    let {
        condition,
        fromPrice,
        toPrice,
        categoryId,
        isNew,
        isHot,
        keyword,
        page,
        goodsType
    } = searchStore

    let history = useHistory()
    let location = useLocation()

    function destroy(){
        searchStore.setKeyword('')
        searchStore.setGoodsList([])
    }

    let urlSearchParams = new URLSearchParams(location.search);
    let qCategoryId = 0;
    if (urlSearchParams.has('categoryId')) {
        qCategoryId = urlSearchParams.get('categoryId')
        qCategoryId = Number(qCategoryId)

/*        if(!categoryId){
            categoryId = qCategoryId;
        }*/
    }

    useEffect(() => {
        searchStore.setCategoryId(qCategoryId)
    }, [qCategoryId]);


    function fetchGoodsList(keyword) {
        let order, sortFiled

        if (condition === SearchOrder.SALE_NUM_ASC) {
            order = ORDER.asc
            sortFiled = ORDER_FILED.saleNum
        } else if (condition === SearchOrder.SALE_NUM_DESC) {
            order = ORDER.des
            sortFiled = ORDER_FILED.saleNum
        } else if (condition === SearchOrder.PRICE_ASC) {
            order = ORDER.asc
            sortFiled = ORDER_FILED.price
        } else if (condition === SearchOrder.PRICE_DESC) {
            order = ORDER.des
            sortFiled = ORDER_FILED.price
        }

        searchStore.setPageNum(1)

        searchStore.fetchGoodsList({
            keyword,
            goodsType,
            categoryId,
            isNew,
            isHot,
            fromPrice,
            toPrice,
            order,
            sortFiled,
            pageSize: SearchReducer.page.size,
            pageNum: SearchReducer.page.num,
        })
    }

    function doSearch() {
        if (location.pathname === Router.Search.path) {
            fetchGoodsList(keyword)
        } else {
            history.push({
                pathname: Router.Search.path,
                //   search: `?keyword=${keyword}`
            })
        }
    }

    useEffect(() => {
        searchStore.init()
        return () => {
            destroy()
        }
    }, [])

    return (
        <css.Search className={className}>
            <css.SearchIconBlock>
                <div className='search-icon-wrapper'>
                    <img
                        src={require('./img/search-icon.png')}
                        alt=''
                        className='search-icon'
                    />
                </div>
            </css.SearchIconBlock>
            <css.SearchInputWrapper>
                <input
                    type='text'
                    className='search-input'
                    value={keyword}
                    onChange={(e) => {
                        const {value} = e.currentTarget
                        searchStore.setKeyword(value)
                        searchStore.fetchRecommendKeywordList({keyword: value})
                    }}
                    onKeyDown={(e) => {
                        if (e.keyCode === 13) {
                            doSearch()
                        }
                    }}
                />
            </css.SearchInputWrapper>
            <css.SearchButton onClick={doSearch}>
                搜索
                {/* <img
          src={require('./img/search-btn-bg.png')}
          alt=''
          className='bg-img'
        /> */}
            </css.SearchButton>

            <div className='bg-img-wrapper'>
                <img src={require('./img/bg.png')} alt='' className='bg-img'/>
            </div>
            {children}
            <css.HotWord as={HotWord} onSearch={doSearch}/>
        </css.Search>
    )
}

export default observer(Search)
